import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getTransaction } from '../services/transactionService';
import BuyerForm from '../pages/BuyerForm';
import SellerForm from '../pages/SellerForm';

// Opens the right edit form for a saved transaction: seller deals use the seller form, everything else uses the buyer form.
export default function TransactionEditRoute() {
  const { id } = useParams();
  const { user } = useAuth();
  const [type, setType] = useState(null);

  useEffect(() => {
    if (!user) return;
    getTransaction(user.uid, id)
      .then((tx) => setType(String(tx?.type || '').toLowerCase()))
      .catch(() => setType('buyer'));
  }, [id, user]);

  if (!type) return <div style={{ padding: 24 }}>Loading transaction...</div>;
  return type === 'seller' ? <SellerForm /> : <BuyerForm />;
}
